module.exports = __webpack_public_path__ + "src/assets/hero-image@2x-100.jpg";